const kalenderMonatSetMonthAction = (config) => ({
  config,
  type: "KALENDER_MONAT_SET_MONTH_ACTION",
});

export { kalenderMonatSetMonthAction };
